import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getActiveChip } from "core-integration/src/store/chips/reducers";
import { getRules } from "core-integration/src/store/game/reducers";
import {
  changeCaptain,
  changeViceCaptain,
} from "core-integration/src/store/my-team/actions";
import { actionSubstitution } from "core-integration/src/store/my-team/thunks";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { Button } from "plos/src/components/buttons/Button";
import { Checkbox } from "plos/src/components/forms/Checkbox";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { actionsGridWrapper, checkBoxItem } from "./myTeamPlayerActions.css";

interface MyTeamPlayerActionsProps {
  handleViewFullProfile: () => void;
  handleClosePlayerSheet: () => void;
  pick: IPickProposed;
}

const MyTeamPlayerActions = ({
  pick,
  handleViewFullProfile,
  handleClosePlayerSheet,
}: MyTeamPlayerActionsProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch<ThunkDispatch>();

  const activeChip = useSelector(getActiveChip);
  const rules = useSelector((state: RootState) =>
    getRules(state, undefined, activeChip?.id),
  );

  const {
    is_captain: isCaptain,
    is_vice_captain: isViceCaptain,
    subStatus: status,
    position,
    element,
  } = pick;

  const substitute = (elementId: number) => {
    handleClosePlayerSheet();
    dispatch(actionSubstitution(elementId));
  };
  const makeCaptain = (elementId: number) => {
    if (isCaptain) return;
    handleClosePlayerSheet();
    dispatch(changeCaptain(elementId));
  };
  const makeViceCaptain = (elementId: number) => {
    if (isViceCaptain) return;
    handleClosePlayerSheet();
    dispatch(changeViceCaptain(elementId));
  };

  const isTarget = status.match(/^(target|)$/);
  const isInstigator = status === "instigator";

  const startMax = rules.squad_squadplay;

  return (
    <div className={actionsGridWrapper}>
      {!status && position <= startMax && (
        <>
          <div className={checkBoxItem}>
            <Checkbox
              isSelected={isCaptain}
              onChange={() => {
                makeCaptain(element);
              }}
            >
              {t("myTeamPlayerActions.captain", "Captain")}
            </Checkbox>
          </div>
          <div className={checkBoxItem}>
            <Checkbox
              isSelected={isViceCaptain}
              onChange={() => makeViceCaptain(element)}
            >
              {t("myTeamPlayerActions.viceCaptain", "Vice Captain")}
            </Checkbox>
          </div>
        </>
      )}
      <Button onPress={handleViewFullProfile} size="small">
        {t("myTeamPlayerActions.fullProfile", "Full Profile")}
      </Button>
      {isTarget && (
        <Button onPress={() => substitute(element)} size="small">
          {t("myTeamPlayerActions.substitute", "Substitute")}
        </Button>
      )}
      {isInstigator && (
        <Button onPress={() => substitute(element)} size="small">
          {t("myTeamPlayerActions.cancel", "Cancel")}
        </Button>
      )}
    </div>
  );
};

export default MyTeamPlayerActions;
